import { PRIVATE_ADMIN_FORM_PERMISSIONGROUP, PRIVATE_ADMIN_LIST_PERMISSIONGROUPS } from "../Constants/PathsConstant";
import FormPermissionGroupView from "../Views/FormPermissionGroupView";
import TablePermissionGroupView from "../Views/TablePermissionGroupView";

export const PermissionGroupRouter = [
  {
    path: PRIVATE_ADMIN_LIST_PERMISSIONGROUPS,
    element: <TablePermissionGroupView />,
    children: [
      
    ]
  },
  {
    path: PRIVATE_ADMIN_FORM_PERMISSIONGROUP + '/:id',
    element: <FormPermissionGroupView />,
    children: [
      
    ]
  }
];